/**
 * Что показать человеку по заданиям завершителя (`GET /jobs` bit-history).
 *
 * Завершитель доводит задачу до Истории после закрытия вкладки; вернувшись,
 * человек должен увидеть «Готово» один раз — на те записи, что доделаны без
 * него. Задачи, которые доделала сама вкладка, отмечены здесь же: их тост
 * повторно не показывает.
 */

/** Доделанные без человека: готовы, ещё не показаны, и вкладка их не вела. */
export function unseenDone(jobs, ownTaskIds = []) {
  const own = new Set(ownTaskIds);
  return (jobs || []).filter((j) => j.status === 'done' && !j.seen_at && !own.has(j.task_id));
}

/** Ещё считаются — для строки «Идёт обработка» по возврату во вкладку. */
export function stillRunning(jobs) {
  return (jobs || []).filter((j) => j.status === 'queued' || j.status === 'running');
}

/** Упавшие без человека: показать причину один раз, как и «Готово». */
export function unseenFailed(jobs, ownTaskIds = []) {
  const own = new Set(ownTaskIds);
  return (jobs || []).filter((j) => j.status === 'failed' && !j.seen_at && !own.has(j.task_id));
}
